/**
 * Sumachay Idle Load Utility
 * Defers non-critical script execution to idle time or user intent.
 * ~400 bytes minified. Idempotent — safe to include multiple times.
 */
(function() {
  if (window.SumachayIdleLoad) return; // idempotent guard

  var queue = [];
  var flushed = false;

  function flush() {
    if (flushed) return;
    flushed = true;
    // Remove intent listeners once flushed
    intentEvents.forEach(function(evt) {
      removeEventListener(evt, flush, true);
    });
    // Execute queued callbacks
    var q = queue.slice();
    queue = [];
    q.forEach(function(fn) { try { fn(); } catch(e) { console.error('[idle-load]', e); } });
  }

  // Intent triggers: first real user interaction
  var intentEvents = ['pointerdown', 'scroll', 'keydown'];
  intentEvents.forEach(function(evt) {
    addEventListener(evt, flush, { once: true, passive: true, capture: true });
  });

  // Also flush on idle or timeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(flush, { timeout: 4000 });
  } else {
    setTimeout(flush, 3000);
  }

  /**
   * Queue a callback to run on idle or first user intent.
   * If already flushed, runs immediately.
   */
  function onIdle(fn) {
    if (flushed) {
      try { fn(); } catch(e) { console.error('[idle-load]', e); }
    } else {
      queue.push(fn);
    }
  }

  /**
   * Load a script on idle/intent. Returns nothing (fire-and-forget).
   * @param {string} src - Script URL
   * @param {object} [opts] - Optional: { defer: bool, async: bool }
   */
  function loadScript(src, opts) {
    opts = opts || {};
    onIdle(function() {
      var s = document.createElement('script');
      s.src = src;
      if (opts.defer) s.defer = true;
      if (opts.async) s.async = true;
      document.head.appendChild(s);
    });
  }

  window.SumachayIdleLoad = {
    onIdle: onIdle,
    loadScript: loadScript,
    _flush: flush // exposed for testing only
  };
})();
